import { AuthPasswordForm } from '@command-center/ui-system';
import { useAuth } from './AuthProvider';

export function ResetPasswordForm() {
  const { updatePassword, signOut } = useAuth();

  async function submit(password: string) {
    const result = await updatePassword(password);
    if (!result.ok) return result;
    await signOut();
    window.history.replaceState({}, '', '/');
    window.location.reload();
    return { ok: true as const };
  }

  return <AuthPasswordForm title="Choose a new password" onSubmit={submit} />;
}
